import AssertionEntity from '../../lib/FormValidator/Assertion/AssertionEntity'
import AssertionItem from '../../lib/FormValidator/Assertion/AssertionItem'
export class PlanillaPartidoOficialMesaNoRegsitradoAssertions extends AssertionEntity {
    private constructor() {
        super()
    }

    static build() {
        const instance = new this()
        instance.addAssertionForName()
        instance.addAssertionForLastName()
        instance.addAssertionForDNI()
        instance.addAssertionForClub()
        return instance
    }

    addAssertionForName(key = 'ppomnr_nombre') {
          this.defineAssertionForProperty(
            key,
            AssertionItem.forClosure(
              (value) => {
                    return value !== ''
                  },
                  key,
                  'Nombre es obligatorio'
                )
              )
            }

            addAssertionForDNI(key = 'ppomnr_dni') {
                this.defineAssertionForProperty(
                  key,
                  AssertionItem.forClosure(
                    (value) => {
                          return value !== ''
                        },
                        key,
                        'DNI es obligatorio'
                      )
                    )
                  }

                  addAssertionForLastName(key = 'ppomnr_apellido') {
                    this.defineAssertionForProperty(
                      key,
                      AssertionItem.forClosure(
                        (value) => {
                              return value !== ''
                            },
                            key,
                            'Apellido es obligatorio'
                          )
                        )
                      }

                      addAssertionForClub(key = 'ppomnr_eqid') {
                        this.defineAssertionForProperty(
                          key,
                          AssertionItem.forClosure(
                            (value) => {
                                  return value !== ''
                                },
                                key,
                                'Club es obligatorio'
                              )
                            )
                          }

            // }

        }

